import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '@visurel/iconify-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { BulletinComponent } from './bulletin.component';

@NgModule({
    declarations: [
        BulletinComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        IconModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatOptionModule,
        FormsModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatButtonModule

    ],
    exports: [
        BulletinComponent
    ]
})
export class BulletinModule
{
}